import { useTranslate } from "@tolgee/react";
import { cn } from "#/lib/utils";

export type ChartSubTab = "chart" | "orderbook" | "trades";

type MobileChartSubTabsProps = {
	active: ChartSubTab;
	onChange: (tab: ChartSubTab) => void;
};

const subTabs: Array<{ key: ChartSubTab; labelKey: string }> = [
	{ key: "chart", labelKey: "mobile.sub.chart" },
	{ key: "orderbook", labelKey: "mobile.sub.orderbook" },
	{ key: "trades", labelKey: "orderbook.tab.trades" },
];

export function MobileChartSubTabs({
	active,
	onChange,
}: MobileChartSubTabsProps) {
	const { t } = useTranslate();

	return (
		<div className="flex items-center border-b border-trade-border-subtle bg-trade-surface">
			{subTabs.map(({ key, labelKey }) => {
				const isActive = active === key;
				return (
					<button
						key={key}
						type="button"
						onClick={() => onChange(key)}
						className={cn(
							"flex-1 relative whitespace-nowrap py-3 transition-colors cursor-pointer",
							isActive
								? "text-label2-medium text-trade-text-strong"
								: "text-label2 text-trade-text-secondary hover:text-trade-text",
						)}
					>
						{t(labelKey, labelKey.split(".").pop())}
						{isActive && (
							<span className="absolute bottom-0 left-0 right-0 h-[2px] bg-primary" />
						)}
					</button>
				);
			})}
		</div>
	);
}
